export default {
    'Type something': 'Comienza a escribir...',
    // About
    'About Jodit': 'Acerca de Jodit',
    'Jodit Editor': 'Editor Jodi',
    'Free Non-commercial Version': 'Versión libre no comercial',
    'Jodit User\'s Guide': 'Guía de usuario - Jodit',
    'contains detailed help for using': 'Contiene ayuda detallada sobre el uso',
    'For information about the license, please go to our website:': 'Para información sobre la licencia, visite nuestro website',
    'Buy full version': 'Compra versión completa',
    'Copyright � XDSoft.net - Chupurnov Valeriy. All rights reserved.': 'Copyright � XDSoft.net - Chupurnov Valeriy. Todos los derechos reservados.',

    // Toolbar
    'Anchor': 'Enlace',
    'Open in new tab': 'Abre en una nueva pestaña',
    'Open editor in fullsize': 'Abre el editor en pantalla completa',
    'Clear Formatting': 'Quita formato de texto',
    'Fill color or set the text color': 'Establece color de fondo o texto',
    'Redo': 'Rehacer',
    'Undo': 'Deshacer',
    'Bold': 'Negrilla',
    'Italic': 'Itálica',
    'Insert Unordered List': 'Inserta lista con viñetas',
    'Insert Ordered List': 'Inserta lista numérica',
    'Align Center': 'Centra',
    'Align Justify': 'Justifica',
    'Align Left': 'Alinea a la izquierda',
    'Align Right': 'Alinea a la derecha',
    'Insert Horizontal Line': 'Inserta línea horizontal',
    'Insert Image': 'Inserta imagen',
    'Insert youtube/vimeo video': 'Inserta vídeo',
    'Insert link': 'Inserta enlace',
    'Font size': 'Tamaño de texto',
    'Font family': 'Fuente de texto',

    'Insert format block': 'Inserta formato',
    'Normal': 'Normal',
    'Heading 1': 'Encabezado 1',
    'Heading 2': 'Encabezado 2',
    'Heading 3': 'Encabezado 3',
    'Heading 4': 'Encabezado 4',
    'Quote': 'Cita',
    'Code': 'Código',

    'Insert': 'Inserta',
    'Insert table': 'Inserta tabla',

    'Paint format': 'Eliminar formato',
    'Change mode': 'Cambia de modo',

    //plugin Image
    'Margins': 'Márgenes',
    'top': 'arriba',
    'right': 'derecha',
    'bottom': 'Abajo',
    'left': 'Izquierda',
    'Styles': 'Estilos',
    'Classes': 'Clases',
    'Align': 'Alinea',
    'Right': 'Derecha',
    'Center': 'Centra',
    'Left': 'Izquierda',
    '--Not Set--': '--No Configurar--',
    'Src': 'Src',
    'Title': 'Título',
    'Alternative': 'Texto alternativo',
    'Link': 'Enlace',
    'Open link in new tab': 'Abre enlace en una nueva pestaña',
    'Image': 'Imagen',
    'Advansed': 'Avanzado',
    'Image properties': 'Propiedades de imagen',
    'Cancel': 'Cancela',
    'Ok': 'Ok',

    // File Browser module
    'File Browser': 'Explora archivos',
    'Error on load list': 'Error en la lista de carga',
    'Error on load folders': 'Error al cargar carpetas',
    'Are you shure?': '¿Estás seguro?',
    'Enter Directory name': 'Ingresa nombre de directorio',
    'Create directory': 'Crea directorio',
    'type name': 'Escribe nombre',

    // Form module
    'Drop image': 'Suelta imagen',
    'or click': 'o clica',
    'Alternative text': 'Texto alternativo',
    'Upload': 'Sube',
    'Browse': 'Previsualiza',
    'Background': 'Fondo',
    'Text': 'Texto',

    // popap module
    'Top': 'Arriba',
    'Middle': 'Medio',
    'Bottom': 'Abajo',
    'Insert column before': 'Inserta columna anterior',
    'Insert column after': 'Inserta columna siguiente',
    'Insert row above': 'Inserta fila arriba',
    'Insert row below': 'Inserta fila abajo',
    'Delete table': 'Borra tabla',
    'Delete row': 'Borra fila',
    'Delete column': 'Borra columna',
    'Empty cell': 'Celda vacía',

    'Embed code': 'Código embebido',
    'Close': 'Cierra',
    'Paste as HTML': 'Pega como html',
    'Your code is similar to HTML. Keep as HTML?': 'Ups, parece que estás pegando un texto con HTML, ¿qué quieres hacer?',
    'Keep': 'Pega con formato',
    'Insert only Text': 'Pega sin formato',
    'Insert as Text': 'Pega con el código html',

    'Words': 'Palabras',
    'Chars': 'Caracteres'

};



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/jodit-es.ts